import dynamic from "next/dynamic";
// import { isIOSDevice } from "./hotel-short-videos.utils";

// const DisabledHotelShortVideos = () => null;

export const HotelShortVideos = dynamic(
  () =>
    // isIOSDevice()
    //   ? Promise.resolve(DisabledHotelShortVideos)
    // :
    import("./hotel-short-videos").then(
      ({ HotelShortVideos }) => HotelShortVideos
    ),
  { ssr: false }
);
